import * as _ from 'lodash'

import Component from "vue-class-component";

import { ReactiveVue } from "@skinsoft/reactive-vue";

import { Item, isWemi } from "@skinsoft/entity";

import { ItemDataStore } from "@skinsoft/entity";

import { MEDIA_ID_CHANGED_FROM_CACHE } from '@skinsoft/bus/src/busTopics';
import { ItemEditScreen, RELOAD_ITEM_EVENT } from '@skinsoft/entity-ui/src/item/components/item-edit-screen';

export interface SoloItemEditScreenRoutes {
    onlineRoute: string,
    offlineRoute: string
}

@Component({
    props: ['itemId', 'itemEditScreen', 'routes'],
    template: require('./solo-item-edit-screen.html'),
})
export class SoloItemEditScreen extends ReactiveVue {
    
    public item: Item = null as any;
    
    private itemId: string;
    
    private itemEditScreen: ItemEditScreen

    private routes: SoloItemEditScreenRoutes

    private $itemDataStore: ItemDataStore;

    private induceUpdate: boolean = false;

    private MEDIA_ID_CHANGED_FROM_CACHE = MEDIA_ID_CHANGED_FROM_CACHE
    private RELOAD_ITEM_EVENT = RELOAD_ITEM_EVENT

    public mounted() {
        this.fetchItem()
    }

    private fetchItem() {
        this.subscribeTo(
            this.$itemDataStore.fetchOne(this.itemId),
            item => {
                if(isWemi(item)) {
                    this.item = (item as any).item
                }
                this.item = item
            }
        )
    }

    public changeMediaId(idChange) {
        this.$set(this.item.associatedMedias, 'first', idChange.newMediaId)
        this.$set(this.item.associatedMedias, 'medias', _.concat(this.item.associatedMedias.medias.filter(m => m !== idChange.oldMediaId && m !== idChange.newMediaId), [idChange.newMediaId]))
        this.induceUpdate = true
    }

    public updateDone() {
        this.induceUpdate = false
        if (this.item?.associatedMedias?.first) {
            this.$set(this.item.associatedMedias, 'illustratedNote', true)
        }
    }

    public closeItemScreen() {
        let route = this.routes.offlineRoute
        if (window.navigator.onLine) {
            route = this.routes.onlineRoute
        }
        this.$router.push({name: route})
    }
}